import { Route } from 'vue-router';

import { baseFilters } from './baseFilters';

/**
 * Filtry partnerów
 *
 * @export
 * @param {Route} route
 * @returns
 */
export function partnerFilters(route: Route) {
  route.query.order = 'name';
  return { ...baseFilters(route, 12), state: 'ACTIVE' };
}
